var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.conditionsDict && _vm.conditionsDict.length > 0
      ? _c("div", [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.getValueFromCondition) },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.conditionsDict || _vm.conditionsDict.length == 0
      ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.formattedValue))])])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }